import EventBus from '@/EventBus';
import ApplicationEventTypes from '@/mixins/ApplicationEventTypes';

const CropHandle = {
  name:   'cropHandle',
  props:  {},
  events: {},
  css:    ['otherTarget'],
  render(moveable, React) {
    const rect     = moveable.getRect();
    const { pos2 } = moveable.state;
    return React.createElement('div', {
      class: 'extended-button crop-button d-flex align-items-center justify-content-center mt-5"',
      style: {
        position:        'absolute',
        left:            '0px',
        top:             '0px',
        transform:       `translate(${pos2[0]}px, ${pos2[1]}px) rotate(${rect.rotation}deg) translate(10px, 0px)`,
        transformOrigin: '0 0',
      },
      key:     'crop-handle',
      onClick: (event) => {
        EventBus.$emit(ApplicationEventTypes.ModalEvents.TOGGLE_CROP_IMAGE_MODAL);
        event.stopPropagation();
      },
    }, '');
  },
};
export default CropHandle;
